// const config = require(`./config_${process.env.NODE_ENV}`).default;
import {getEnvironmentName} from "./utils"
const environment = getEnvironmentName()
const config = require("app_configuration").CONFIGURATION[environment];

export let amplifyConfig = {
  Auth: {
    identityPoolId: config.AWS_COGNITO_IDENTITY_POOL_ID, // REQUIRED - Amazon Cognito Identity Pool ID
    region: config.AWS_REGION, // REQUIRED - Amazon Cognito Region
    userPoolId: config.AWS_COGNITO_USER_POOL_ID, //OPTIONAL - Amazon Cognito User Pool ID
    userPoolWebClientId: config.AWS_COGNITO_CLIENT_ID //OPTIONAL - Amazon Cognito Web Client ID
  },
  Analytics: {
    disabled: false,
    autoSessionRecord: true,

    AWSPinpoint: {
      appId: config.AWS_PINPOINT_APP_ID,
      region: config.AWS_REGION,
      mandatorySignIn: false
    }
  },
  API: {
    endpoints: [
      {
        name: config.AWS_API_NAME,
        endpoint: config.AWS_API_URL,
        service: config.AWS_API_SERVICE,
        region: config.AWS_REGION
      }
    ]
  },
  Interactions: {
    bots: {}
  },
  Storage: {
    AWSS3: {
      level: "public",
      bucket: "ev-pre-prod-profile-pics", //REQUIRED -  Amazon S3 bucket
      region: "us-east-1" //OPTIONAL -  Amazon service region
    }
  }
};
